import React, { useEffect } from "react";
import AppRouter from "./routes/routes";
import "./i18n";
function App() {
  

  useEffect(() => {
    // Event listeners to disable copy, right-click, and mouse interaction
    // const disableCopy = (event) => event.preventDefault();
    const disableRightClick = (event) => event.preventDefault();
    // const disableMouseInteraction = (event) => event.preventDefault();

    // document.addEventListener("copy", disableCopy);
    document.addEventListener("contextmenu", disableRightClick);
    // document.addEventListener("mousedown", disableMouseInteraction);

    // Cleanup event listeners on unmount
    return () => {
      // document.removeEventListener("copy", disableCopy);
      document.removeEventListener("contextmenu", disableRightClick);
      // document.removeEventListener("mousedown", disableMouseInteraction);
    };
  }, []);

  return <AppRouter />;
}

export default App;
